import useRoles from "backend/hooks/workflows/useRoles";
import useWorkflowConfigurations from "backend/hooks/workflows/useWorkflowConfigurations";
import * as wf from "client-api-workflow";
import * as wfTypes from "client-api-workflow/types";
import WorkflowAdminToolbar from "components/toolbars/WorkflowAdminToolbar";
import AdminButton from "design/components/buttons/AdminButton";
import MeasureTable from "design/components/tables/MeasureTable";
import ExecutiveDashboardTitle from "design/components/texts/ExecutiveDashboardTitle";
import PageContainer from "design/layouts/PageContainer";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import Loader from "qpr-base/ui/components/Loader";
import React from "react";

const WorkflowConfigs = () => {
  const ctx = useAppContext();
  const link = useLink();
  const tbl = useWorkflowConfigurations();
  const roles = useRoles();

  if (!tbl.data) return <Loader />;
  return (
    <div style={{ width: "100%" }}>
      <WorkflowAdminToolbar />
      <PageContainer>
        <div
          onPaste={(event) => {
            const value = event.clipboardData.getData("text");
            try {
              const obj = JSON.parse(value) as wfTypes.WFConfigParams;
              const newConfigObj: wfTypes.WFConfigParams = {
                name: obj.name,
                startPeriod: obj.startPeriod,
                endPeriod: obj.endPeriod,
                configuration: obj.configuration,
                workflowCreationDate: obj.workflowCreationDate,
                modelId: ctx.fullModelId || "",
                type: obj.type,
              };

              const old = tbl.data?.find((it) => it.name === newConfigObj.name);

              if (old) {
                wf.updateWorkflowConfiguation({
                  _id: obj._id,
                  ...newConfigObj,
                }).then(() => {
                  window.location.reload();
                });
              } else {
                wf.createWorkflowConfiguration(newConfigObj).then(() => {
                  console.log("Created a new configuration");
                  window.location.reload();
                });
              }
            } catch (e) {
              console.log(e);
            }
          }}
        >
          <ExecutiveDashboardTitle>
            Workflow Configurations
          </ExecutiveDashboardTitle>
          <MeasureTable
            items={tbl.data!}
            columns={[
              {
                title: "ID",
                value: (row) => <div>{row.elem._id}</div>,
              },
              {
                title: "Name",
                value: (row) => <div>{row.elem.name}</div>,
              },
              {
                title: "Start Period",
                value: (row) => <div>{row.elem.startPeriod}</div>,
              },
              {
                title: "End Period",
                value: (row) => <div>{row.elem.endPeriod}</div>,
              },
              {
                title: "Model ID",
                value: (row) => <div>{row.elem.modelId}</div>,
              },
              {
                title: "Offset Days",
                value: (row) => (
                  <div>{row.elem.workflowCreationDate?.offsetDays}</div>
                ),
              },
              {
                title: "Start of Period",
                value: (row) => (
                  <div>{row.elem.workflowCreationDate?.startOfPeriod}</div>
                ),
              },
              {
                title: "Actions",
                value: (row) => (
                  <div style={{ display: "flex", gap: "5px" }}>
                    <AdminButton
                      onClick={() => {
                        navigator.clipboard.writeText(
                          JSON.stringify(row.elem, null, 2)
                        );
                      }}
                    >
                      Copy to Clipboard
                    </AdminButton>
                    <AdminButton
                      onClick={() => {
                        // eslint-disable-next-line
                        if (
                          window.confirm(
                            "Are you sure you want to delete the workflow configuration?"
                          )
                        ) {
                          wf.deleteWorkflowConfiguration(row.elem.id);
                          window.location.reload();
                        }

                        // (row.elem.id);
                      }}
                    >
                      Delete
                    </AdminButton>
                  </div>
                ),
              },
            ]}
          />
        </div>
        <div
          onPaste={(event) => {
            const value = event.clipboardData.getData("text");
            try {
              const obj = JSON.parse(value) as wfTypes.WFRoleParams & {
                id: string;
              };
              const newConfigObj: wfTypes.WFRoleParams = {
                name: obj.name,
                type: obj.type,
                meaGroups: obj.meaGroups,
                symbol: obj.symbol,
              };

              const old = roles.data?.find(
                (it) => it.name === newConfigObj.name
              );

              if (old) {
                console.log("UPDATE ROLE ", newConfigObj);
                wf.updateRole(obj.id, newConfigObj).then(() => {
                  window.location.reload();
                });
              } else {
                wf.createNewRole(newConfigObj).then(() => {
                  console.log("Created a new configuration");
                  window.location.reload();
                });
              }
            } catch (e) {
              console.log(e);
            }
          }}
        >
          <ExecutiveDashboardTitle>Roles</ExecutiveDashboardTitle>

          <MeasureTable
            items={roles.data || []}
            columns={[
              {
                title: "ID",
                value: (row) => <div>{row.elem._id}</div>,
              },
              {
                title: "Name",
                value: (row) => <div>{row.elem.name}</div>,
              },
              {
                title: "Actions",
                value: (row) => (
                  <div style={{ display: "flex", gap: "5px" }}>
                    <AdminButton
                      onClick={() => {
                        navigator.clipboard.writeText(
                          JSON.stringify(
                            { ...row.elem, symbol: row.elem.name },
                            null,
                            2
                          )
                        );
                      }}
                    >
                      Copy to Clipboard
                    </AdminButton>
                    <AdminButton
                      onClick={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to delete the role?"
                          )
                        ) {
                          wf.deleteRole(row.elem.id);
                          window.location.reload();
                        }
                      }}
                    >
                      Delete
                    </AdminButton>
                  </div>
                ),
              },
            ]}
          />
        </div>
      </PageContainer>
    </div>
  );
};
export default WorkflowConfigs;
